<template>
  <v-content class="pa-12">
    <v-layout justify-space-around>
      <v-flex
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>โครงการวิจัยที่ผ่านการพิจารณา</span>
      </v-flex>
    </v-layout>

    <v-row>
      <v-col cols="3">
        <v-text-field
            placeholder="รหัสโครงการวิจัย"
            color="#3e7662"
            dense
            outlined
            v-model="searchData.researchCode"
            hide-details
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
            placeholder="ชื่อ นามสกุล ผู้วิจัย"
            color="#3e7662"
            dense
            outlined
            v-model="searchData.researcherName"
            hide-details
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
            placeholder="เลขรับ"
            color="#3e7662"
            dense
            outlined
            v-model="searchData.initialNumber"
            hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-select
            hide-details
            clearable
            :menu-props="{ bottom: true, offsetY: true }"
            background-color="#3e7662"
            dark
            solo
            flat
            dense
            label="ประเภทการพิจารณา"
            :items="considerationType"
            item-text="name"
            item-value="id"
            v-model="searchData.considerationType_id"
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
            placeholder="ชื่อโครงการวิจัย"
            color="#3e7662"
            dense
            outlined
            v-model="searchData.researchName"
            hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <DateInputForm
            :model="dateChange.startDate"
            @update-data="updateDate('startDate', $event)"
            label="ตั้งแต่"
        >
        </DateInputForm>
      </v-col>
      <v-col cols="3">
        <DateInputForm
            :model="dateChange.endDate"
            @update-data="updateDate('endDate', $event)"
            label="จนถึง"
        >
        </DateInputForm>
      </v-col>
      <v-col class="shrink d-flex justify-end">
        <v-btn color="#3e7662" dark @click="getPaginateResearchFilter(1)">
          <span class="font-weight-bold">ค้นหา</span>
        </v-btn>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-layout mt-4>
      <v-flex>
        <form-table
          :headers="headers"
          :items="researchList"
          onViewData
          :on-approve="onApprove"
          :on-approve-regen="onApproveRegen"
          :on-mail-send="onMailSend"
          :on-mail-resend="onMailResend"
        ></form-table>
      </v-flex>
    </v-layout>

    <!-- Pagination -->
    <v-layout mt-12>
      <v-flex>
        <v-pagination
          color="#3E7662"
          :length="paginate.last_page"
          :total-visible="9"
          @input="getPaginateResearchFilter($event)"
          v-model="paginate.current_page"
        ></v-pagination>
      </v-flex>
    </v-layout>

    <!-- APPROVE MODAL -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <!-- Header 1 -->
            <v-card-title
              class="justify-center font-weight-bold"
              style="background-color: #3e7662;color: #fff;font-size: 26px"
            >
              <span>ลงนามอนุมัติ</span>
            </v-card-title>
            <!-- Card text 1 -->
            <v-card-text>
              <!-- row 0 -->

              <v-divider class="mb-6"></v-divider>

              <v-layout
                class="py-2 font-weight-bold"
                style="background-color: #3e7662;color: white;font-size: 18px;"
              >
                <v-flex>
                  <span>กรุณายืนยันตัวตน</span>
                </v-flex>
              </v-layout>
              <v-card class="px-6 pb-6">
                <!-- row 0 -->
                <v-layout class="py-4">
                  <v-flex>
                    <span style="font-weight: bold;color: #CC3D45;"
                      >*การยืนยันตัวตนนี้ เพื่อเป็นการ "ลงนามอนุมัติ"
                      งานวิจัยสำหรับผู้มีสิทธิ์ในการอนุมัติเท่านั้น</span
                    >
                  </v-flex>
                </v-layout>
                <!-- row 1 -->
                <v-layout>
                  <v-flex xs3 mr-3 justify-end align-center d-flex>
                    <span style="font-weight: bold;">Username: </span>
                  </v-flex>
                  <v-flex justify-start align-center d-flex>
                    <v-text-field
                      color="#3e7662"
                      v-model="form.email"
                      dense
                      outlined
                      hide-details
                    />
                  </v-flex>
                </v-layout>
                <!-- row 2 -->
                <v-layout mt-6>
                  <v-flex xs3 mr-3 justify-end align-center d-flex>
                    <span style="font-weight: bold;">Password: </span>
                  </v-flex>
                  <v-flex justify-start align-center d-flex>
                    <v-text-field
                      type="password"
                      color="#3e7662"
                      v-model="form.password"
                      outlined
                      dense
                      hide-details
                      @keyup.enter="approveResearch"
                    />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-card-text>

            <v-card-actions class="pb-12 pr-12">
              <v-layout>
                <v-spacer></v-spacer>
                <v-flex shrink mr-3 justify-end>
                  <v-btn
                    depressed
                    style="font-weight: bold"
                    @click="dialog = false"
                    ><span style="color: #3e7662">ยกเลิก</span></v-btn
                  >
                </v-flex>
                <v-flex shrink justify-end>
                  <v-btn
                    depressed
                    dark
                    color="#3E7662"
                    style="font-weight: bold"
                    @click="approveResearch"
                    >ยืนยัน</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!--EMAIL SEND MODAL-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="emailDialog" persistent max-width="1000px">
          <v-card>
            <!-- Header Title -->
            <v-card-title
              class="justify-center font-weight-bold"
              style="background-color: #3e7662;color: #fff;font-size: 26px"
            >
              <span>ส่ง Email</span>
            </v-card-title>

            <!-- Card แนบเอกสาร (มีตราประทับ) -->
            <v-card-text class="pa-12">
              <v-layout
                class="py-2 font-weight-bold"
                style="background-color: #3e7662;color: white;font-size: 18px;"
              >
                <v-flex>
                  <span>แนบเอกสาร (มีตราประทับ)</span>
                </v-flex>
              </v-layout>
              <v-card class="px-6 pb-6">
                <v-layout>
                  <v-flex mt-2 xs5
                    ><p style="color: red;text-align: left;font-weight: bold">
                      *PDF Version 1.4 เท่านั้น!
                    </p></v-flex
                  >
                  <v-flex xs6 mt-6 style="text-align: right;">
                    <v-btn
                      min-width="5px"
                      small
                      dark
                      style="background-color: #3E7662;padding: 5px"
                      @click="add('attachFiles')"
                    >
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs1 ml-2></v-flex>
                </v-layout>

                <v-layout
                  v-for="(item, i) in emailForm.attachStampFiles"
                  :key="i"
                  mb-6
                  mt-6
                  class="justify-center"
                >
                  <v-flex xs5>
                    <v-layout>
                      <v-flex shrink mr-3 class="pt-2">
                        <span class="font-weight-bold">ชื่อเอกสาร</span>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          prepend-icon=""
                          v-model="item.name"
                          outlined
                          dense
                          background-color="#FBF6F3"
                          color="#3E7662"
                          item-color="#3E7662"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs6 pl-4>
                    <v-layout class="justify-center">
                      <v-flex shrink class="pt-3 font-weight-bold mr-3"
                        >ไฟล์</v-flex
                      >
                      <v-flex>
                        <v-layout class="mb-2">
                          <v-flex xs10 class="text-start">
                            <v-file-input
                              accept=".pdf"
                              prepend-icon=""
                              :id="'stampFile' + i"
                              :model="item.file"
                              outlined
                              dense
                              background-color="#FBF6F3"
                              color="#3E7662"
                              item-color="#3E7662"
                              @change="setDataUploadDynamicStampFile($event, i)"
                              hide-details
                            ></v-file-input>
                          </v-flex>
                          <v-flex
                            shrink
                            pl-4
                            style="text-align: left"
                            class="d-flex align-center"
                          >
                            <v-btn
                              color="#3E7662"
                              dark
                              @click="uploadDynamicStampFile('stampFile' + i)"
                            >
                              <v-icon class="pr-3">cloud_download</v-icon>
                              <span>Upload</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1 pt-2 ml-2>
                    <v-btn
                      v-if="emailForm.attachStampFiles.length > 1"
                      min-width="5px"
                      small
                      dark
                      style="background-color: #CC3D45;padding: 5px"
                      @click="remove(i)"
                    >
                      <v-icon small>remove</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card>

              <v-layout
                class="py-2 font-weight-bold"
                style="background-color: #3e7662;color: white;font-size: 18px;"
              >
                <v-flex>
                  <span>แนบเอกสาร (ไม่มีตราประทับ)</span>
                </v-flex>
              </v-layout>
              <v-card class="px-6 pb-6">
                <v-layout>
                  <v-flex mt-2 xs5>
                    <p style="color: red;text-align: left;font-weight: bold">
                      *PDF เท่านั้น!
                    </p></v-flex
                  >
                  <v-flex xs6 mt-6 style="text-align: right;">
                    <v-btn
                      min-width="5px"
                      small
                      dark
                      style="background-color: #3E7662;padding: 5px"
                      @click="add2"
                    >
                      <v-icon small>add</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs1 ml-2></v-flex>
                </v-layout>

                <v-layout
                  v-for="(item, i) in emailForm.attachFiles"
                  :key="i"
                  mb-6
                  mt-6
                  class="justify-center"
                >
                  <v-flex xs5>
                    <v-layout>
                      <v-flex shrink mr-3 class="pt-2">
                        <span class="font-weight-bold">ชื่อเอกสาร</span>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          prepend-icon=""
                          v-model="item.name"
                          outlined
                          dense
                          background-color="#FBF6F3"
                          color="#3E7662"
                          item-color="#3E7662"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs6 pl-4>
                    <v-layout class="justify-center">
                      <v-flex shrink class="pt-3 font-weight-bold mr-3"
                        >ไฟล์</v-flex
                      >
                      <v-flex>
                        <v-layout class="mb-2">
                          <v-flex xs10 class="text-start">
                            <v-file-input
                              accept=".pdf"
                              prepend-icon=""
                              :id="'file' + i"
                              :model="item.file"
                              outlined
                              dense
                              background-color="#FBF6F3"
                              color="#3E7662"
                              item-color="#3E7662"
                              @change="
                                setDataUploadDynamicFile(
                                  'attachFiles',
                                  $event,
                                  i
                                )
                              "
                              hide-details
                            ></v-file-input>
                          </v-flex>
                          <v-flex
                            shrink
                            pl-4
                            style="text-align: left"
                            class="d-flex align-center"
                          >
                            <v-btn
                              color="#3E7662"
                              dark
                              @click="uploadDynamicFile('file' + i)"
                            >
                              <v-icon class="pr-3">cloud_download</v-icon>
                              <span>Upload</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1 pt-2 ml-2>
                    <v-btn
                      v-if="emailForm.attachFiles.length > 1"
                      min-width="5px"
                      small
                      dark
                      style="background-color: #CC3D45;padding: 5px"
                      @click="remove2(i)"
                    >
                      <v-icon small>remove</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-card-text>

            <v-card-actions class="pb-12 pr-12">
              <v-layout>
                <v-spacer></v-spacer>
                <v-flex shrink mr-3 justify-end>
                  <v-btn
                    depressed
                    style="font-weight: bold"
                    @click="previewMail"
                    ><span style="color: #3e7662">ดูตัวอย่างอีเมล</span></v-btn
                  >
                </v-flex>
                <v-flex shrink mr-3 justify-end>
                  <v-btn
                    depressed
                    style="font-weight: bold"
                    @click="emailDialog = false"
                    ><span style="color: #3e7662">ยกเลิก</span></v-btn
                  >
                </v-flex>
                <v-flex shrink justify-end>
                  <v-btn
                    depressed
                    dark
                    color="#3E7662"
                    style="font-weight: bold"
                    @click="sendApproveMail"
                    >ยืนยัน</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import FormTable from "../../components/table/FormTable";
import DateInputForm from "../../components/input/DateInputForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-select/dist/vue-select.css";
import { mapState, mapActions } from "vuex";
import axios from "axios";
import { domain } from "../../services/Constants";

export default {
  name: "Leader",
  components: {
    FormTable,
    Loading,
    DateInputForm,
  },
  data: () => ({
    // modal dialog
    dialog: false,
    emailDialog: false,
    emailForm: {
      attachFiles: [
        {
          file: "",
          name: "",
        },
      ],
      attachStampFiles: [
        {
          file: "",
          name: "",
        },
      ],
    },
    form: {
      month: "",
      ortherMonth: "",
      email: "",
      password: "",
      researchID: "",
    },
    isLoading: false,
    fullPage: true,
    paginate: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    headers: [
      { text: "ลำดับ", value: "number", align: "center", sortable: false },
      { text: "ชื่องานวิจัย", value: "nameResearch", align: "center" },
      { text: "ชื่อผู้วิจัย", value: "nameResearcher", align: "center" },
      {
        text: "รหัสโครงร่าง การวิจัย",
        value: "researchCode",
        align: "center",
        sortable: false,
      },
      {
        text: "ประเภทการพิจารณา",
        value: "considerType",
        align: "center",
        sortable: false,
      },
      { text: "เวอร์ชั่น", value: "version", align: "center", sortable: false },
      {
        text: "สถานะ",
        value: "considerResult",
        align: "center",
        sortable: false,
      },
      {
        text: "ดูโครงร่างการวิจัย",
        value: "viewOutlineResearch",
        align: "center",
        sortable: false,
      },
      {
        text: "ลงนามอนุมัติ",
        value: "signApprove",
        align: "center",
        sortable: false,
      },
      {
        text: "ส่ง email",
        value: "emailSend",
        align: "center",
        sortable: false,
      },
      {
        text: "Download RL 01_2563",
        value: "viewPDF",
        align: "center",
        sortable: false,
      },
      {
        text: "สร้างเอกสารอีกครั้ง",
        value: "regenPDF",
        align: "center",
        sortable: false,
      },
    ],
    researchList: [],
    dateChange: {
      startDate: '',
      endDate: ''
    },
    considerationType: [
      { id:"0", value: "4", name: "ทั้งหมด", isResubmission: "0" },
      { id:"1", value: "1", name: "ประเภท Full Board", isResubmission: "0" },
      { id:"2", value: "2", name: "ประเภท Expedited", isResubmission: "0" },
      { id:"3", value: "3", name: "ประเภท Exemption", isResubmission: "0" },
      { id:"4", value: "1", name: "ประเภท Full Board (แก้ไขเพื่อรับรอง)", isResubmission: "1" },
      { id:"5", value: "2", name: "ประเภท Expedited (แก้ไขเพื่อรับรอง)", isResubmission: "1" },
    ],
    searchData: {
      startDate: '',
      endDate: '',
      researchCode: "",
      researcherName: "",
      considerationType_id: "0",
      considerType: "0",
      initialNumber: "",
      isResubmission: "0",
      researchName:""
    },
    filterType: "4",
    checkRadio1: false,
    checkRadio2: false,
    checkRadio3: false,
    checkRadio4: false,
    isRegen: false
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    // Check Permission Access
    //   if (this.user.currentRole !== 4) {
    //        this.$router.go(-1);
    //   }
    this.getPaginateResearchFilter(1);
  },
  methods: {
    checkRadio(name) {
      if (name === "1") {
        this.checkRadio1 = true;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        // this.filterType = '1';
        this.form.ortherMonth = "";
      }
      if (name === "2") {
        this.checkRadio1 = false;
        this.checkRadio2 = true;
        this.checkRadio3 = false;
        this.checkRadio4 = false;
        this.form.ortherMonth = "";
        // this.filterType = '2';
      }
      if (name === "3") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = true;
        this.checkRadio4 = false;
        // this.filterType = '3';
      }
      if (name === "4") {
        this.checkRadio1 = false;
        this.checkRadio2 = false;
        this.checkRadio3 = false;
        this.checkRadio4 = true;
        this.filterType = "4";
      }
      this.getPaginateResearchFilter(1);
    },

    getPaginateResearchFilter(page) {
      // let data = {
      //   page: page,
      //   considerType: this.filterType,
      // };
      this.searchData.page = page;
      let considerType = this.considerationType.find(x => x.id === this.searchData.considerationType_id);
      this.searchData.isResubmission = considerType.isResubmission
      this.searchData.considerType = considerType.value
      this.isLoading = true;
      this.$store
        .dispatch("Research/getPaginateResearchFilter", this.searchData)
        .then((res) => {
          this.isLoading = true;
          this.researchList = [];
          let i = 1;
          res.data.forEach((data) => {
            this.researchList.push({
              number: i,
              researchID: data.id,
              nameResearch: data.thResearchName,
              nameResearcher:
                data.user.preNameTh ? data.user.preNameTh + " " + data.user.thName : data.user.thName,
              researchCode: data.researchCode,
              considerType: data.research_type,
              considerResult: data.status ? data.status : "-",
              version: data.version ? data.version : "-",
              data: data,
              status: data.status === "อนุมัติ" ? false : true,
              isSendApproveMail: data.isSendApproveMail == 1,
              mailLink: domain+'research-email/'+data.id+'?email_type=approve',
              onView: 4,
            });
            i++;
          });
          this.paginate.current_page = res.current_page;
          this.paginate.from = res.from;
          this.paginate.last_page = res.last_page;
          this.paginate.per_page = res.per_page;
          this.paginate.total = res.total;
          this.paginate.to = res.to;
          this.isLoading = false;
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
        });
    },
    onMailResend(id){
      Swal.fire({
        title: "ท่านต้องการส่งอีเมลอีกครั้งหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ต้องการ",
        cancelButtonText: "ยกเลิก",
      }).then((res) => {
        if(res.value) {
          this.isLoading = true;
          let payload = {'id': id, 'email_type': 'approve'}
          this.$store.dispatch("Research/researchEmailResend", payload)
              .then((res) => {
                this.isLoading = false;
                console.log('res', res)
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "ส่งอีเมลซ้ำเรียบร้อยแล้ว",
                  showConfirmButton: false,
                  timer: 1500,
                })
              }).catch((e) => {
            Swal.fire({
              icon: "error",
              title: "เกิดข้อผิดพลาด",
              text: e.response.data.message,
              confirmButtonColor: "#3E7662",
            });
            this.isLoading = false;
          });
        }
      })
    },
    checkConsiderType(val) {
      if (val === 1) {
        return "Full Board";
      }
      if (val === 2) {
        return "Expedited";
      }
      if (val === 3) {
        return "Exemption";
      }
    },
    onApprove(val) {
      // console.log('onApprove: ', val)
      this.form.researchID = val.researchID;
      this.isRegen = false;
      this.dialog = true;
    },
    onApproveRegen(val) {
      // console.log('onApprove: ', val)
      this.form.researchID = val.researchID;
      this.isRegen = true;
      Swal.fire({
        title: 'คุณต้องการสร้างเอกสารอีกครั้งหรือไม่?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3E7662',
        cancelButtonColor: 'rgb(189, 189, 189)',
        confirmButtonText: 'ใช่ บันทึก',
      }).then((result) => {
        if(result.value){
          this.approveResearch()
        }

      })
    },
    onMailSend(val) {
      this.emailForm.researchID = val.researchID;
      this.emailDialog = true;
    },
    uploadDynamicStampFile(val) {
      document.getElementById(val).click();
    },
    setDataUploadDynamicStampFile(val, index) {
      this.isLoading = true;
      var formData = new FormData();
      formData.append("approveMailAttachFile", val);
      axios
        .post(domain + "/api/upload-file-pre", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.emailForm.attachStampFiles[index].file = response.data.fileName;
          this.isLoading = false
        })
        .catch(function(error) {this.isLoading = false});
    },
    uploadDynamicFile(val) {
      document.getElementById(val).click();
    },
    setDataUploadDynamicFile(name, val, index) {
      this.isLoading = true;
      var formData = new FormData();
      formData.append("approveMailAttachFile", val);
      axios
        .post(domain + "/api/upload-file-pre", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.emailForm[name][index].file = response.data.fileName;
          this.isLoading = false
        })
        .catch(function(error) {
          console.log(error);
          this.isLoading = false
        });
    },
    add() {
      this.emailForm.attachStampFiles.push({ name: "", file: "" });
    },
    remove(index) {
      this.emailForm.attachStampFiles.splice(index, 1);
    },
    add2() {
      this.emailForm.attachFiles.push({ name: "", file: "" });
    },
    remove2(index) {
      this.emailForm.attachFiles.splice(index, 1);
    },
    approveResearch() {
      this.isLoading = true;
      let api = 'Auth/verifyApprove'
      let title = 'อนุมัติงานวิจัยเรียบร้อยแล้ว'
      if(this.isRegen) {
        api = 'Auth/verifyApproveRegen'
        title = 'สร้างเอกสารใหม่สำเร็จ'
      }
      this.$store
        .dispatch(api, this.form)
        .then((res) => {
          this.isLoading = false;
          Swal.fire({
            position: "center",
            icon: "success",
            title: title,
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.form.email = "";
            this.form.password = "";
            this.form.month = "";
            this.form.ortherMonth = "";
            this.dialog = false;
            this.getPaginateResearchFilter(1);
          });
        })
        .catch((e) => {
          if(e.response && e.response.message){
            Swal.fire({
              icon: "error",
              title: e.response.message,
              text: e.response.data.message,
              confirmButtonColor: "#3E7662",
            });
          }else {
            Swal.fire({
              icon: "error",
              title: "เกิดข้อผิดพลาด",
              text: e.response.data.message,
              confirmButtonColor: "#3E7662",
            });
          }
          this.form.email = "";
          this.form.password = "";
          this.form.month = "";
          this.form.ortherMonth = "";
          this.isLoading = false;
          this.dialog = false;
        });
    },
    sendApproveMail() {
      this.isLoading = true;
      this.$store.dispatch("Research/sendApproveMail", this.emailForm)
          .then((res) => {
            this.isLoading = false;
            Swal.fire({
              position: "center",
              icon: "success",
              title: "อนุมัติงานวิจัยเรียบร้อยแล้ว",
              showConfirmButton: false,
              timer: 1500,
            }).then(() => {
              this.emailForm = {
                attachFiles: [
                  {
                    file: "",
                    name: "",
                  },
                ],
                attachStampFiles: [
                  {
                    file: "",
                    name: "",
                  },
                ],
              };
              this.emailDialog = false;
              this.getPaginateResearchFilter(1);
            });
          })
          .catch((e) => {
            Swal.fire({
              icon: "error",
              title: "เกิดข้อผิดพลาด",
              text: e.response.data.message,
              confirmButtonColor: "#3E7662",
            });
            this.isLoading = false;
            this.dialog = false;
          });
    },
    previewMail() {
      this.isLoading = true;
      this.$store.dispatch("Research/previewApproveMail", this.emailForm)
          .then((res) => {
            console.log('res',res)
            var pageLink = "about:blank";
            var pwa = window.open(pageLink, "_new");
            pwa.document.open();
            pwa.document.write(res);
            pwa.document.close();
            this.isLoading = false;
          })
          .catch((e) => {
            Swal.fire({
              icon: "error",
              title: "เกิดข้อผิดพลาด",
              text: e.response.data.message,
              confirmButtonColor: "#3E7662",
            });
            this.isLoading = false;
          });
    },
    updateDate(name, val) {
        this.searchData[name] = val.date;
        this.dateChange[name] = this.changeDate(val.date);
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);

      sub_year = parseInt(sub_year) + 543;

      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
  },
};
</script>

<style></style>
